import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// Helpers
import { clone } from "@Common/helpers/Modifiers/formatters";

// Layouts
import SingleTiersLoader from "@Layouts/components/Skeletons/SingleTiersLoader";

// Components
import LongevitySection from "./Section";

// MUI
import { Grid } from "@mui/material";

function Longevity(props) {
	const {
		sectionId = "longevity",
		content = [],
		constraints = null,
		loading = false,
		readOnly = false,
		onActionUpdate = () => {},
		useSectionsErrors = () => {},
	} = props;

	// Used to add errors to the pay plan context
	const { addSectionError, removeSectionError, clearSectionErrors } = useSectionsErrors?.() || {};

	// States
	const [model, setModel] = useState([]);

	// Action Handlers
	const handleUpdate = (data) => {
		setModel(data);
		onActionUpdate?.(sectionId, null, data);
	};

	const handleValidation = (isValid) => {
		isValid ? removeSectionError?.(sectionId) : addSectionError?.(sectionId);
	};

	useEffect(() => {
		setModel(clone(content));
		return () => {
			setModel([]);
			clearSectionErrors?.(sectionId);
		};
	}, [sectionId, content, clearSectionErrors]);

	if (loading) {
		return (
			<Grid container sx={{ marginTop: "15px", padding: "0px 30px" }}>
				<SingleTiersLoader tiers={1} buttons sx={{ padding: "0px" }} />
			</Grid>
		);
	}

	return (
		<LongevitySection
			rows={model || []}
			constraints={constraints}
			readOnly={readOnly}
			onActionUpdate={handleUpdate}
			onActionValidation={handleValidation}
		/>
	);
}
Longevity.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.array,
	constraints: PropTypes.object,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

export default Longevity;
